import { roundValue, getUnit } from '@/util/format.js';

const formatNumber = function(value, significantDigits = 2) {
    const unit = getUnit(value);
    value = roundValue(value, unit.value, significantDigits);
    return this.$i18n(`moderation.units.${unit.key}`, { value });
};

export const formatPlugin = {
    install(Vue) {
        Vue.prototype.$formatNumber = formatNumber;
    },
};
